import axios from 'axios';
import retry from 'p-retry';
import { shouldRetryHandler } from './common';
import { Logger } from '@/middlewares/sentry';

const handleGoogleError = (error) => {
  if (!error.response) {
    Logger.error('Server connection error ' + error);
    throw new Error(
      JSON.stringify({
        status: 408,
        message: 'No connection with server.',
      }),
    );
  }

  Logger.error(error);
  throw new Error(
    JSON.stringify({
      status: error.response.status,
      message: error.response.data?.error ?? 'Unknow error',
    }),
  );
};

class GoogleService {
  setAuthToken(token: string) {
    this.token = token;
  }

  getDownloadLink(fileId: string): Promise<string> {
    return retry(
      async () => {
        try {
          await axios.post(
            `https://www.googleapis.com/drive/v3/files/${fileId}/permissions`,
            {
              role: 'reader',
              type: 'anyone',
            },
            {
              headers: {
                Authorization: `Bearer ${this.token}`,
              },
            },
          );

          const downloadLink = `https://drive.google.com/uc?id=${fileId}&export=download`;
          return downloadLink;
        } catch (error) {
          handleGoogleError(error);
        }

        return '';
      },
      {
        retries: 2,
        minTimeout: 2000,
        shouldRetry: (error) => shouldRetryHandler(error),
      },
    );
  }

  uploadFile(formData: FormData): Promise<string> {
    return retry(
      async () => {
        try {
          const resp = await axios.post(
            'https://www.googleapis.com/upload/drive/v3/files',
            formData,
            {
              headers: {
                Authorization: `Bearer ${this.token}`,
              },
            },
          );

          const fileId = resp.data.id;
          return fileId;
        } catch (error) {
          handleGoogleError(error);
        }
      },
      {
        retries: 2,
        minTimeout: 2000,
        shouldRetry: (error) => shouldRetryHandler(error),
      },
    );
  }

  token = '';
}

export default new GoogleService();
